import { IDocument } from '../../types/newbuilding/document';
import { IApplicationState } from '../../types/redux';

export function getDocuments(state: IApplicationState): IDocument[] {
  return state.newbuilding.documentation || [];
}
